"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewAssetAggregateDataRequest extends new_item_1.default {
    constructor(newAssetAggregateDataRequest) {
        super();
        this.assetId = newAssetAggregateDataRequest.assetId;
        this.start = newAssetAggregateDataRequest.start;
        this.end = newAssetAggregateDataRequest.end;
        this.status = newAssetAggregateDataRequest.status;
    }
}
exports.default = NewAssetAggregateDataRequest;
//# sourceMappingURL=new-assetAggregateDataRequest.js.map